// extracted by mini-css-extract-plugin
module.exports = {"offices":"Offices_offices__3LTXb","bubbles_title":"Offices_bubbles_title__3f5Gh","bubbles_title2":"Offices_bubbles_title2__2EnBb"};